import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageHero } from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import { api } from "@/lib/api";

export default function Services() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    api.get("/services").then(({ data }) => setServices(data)).catch(() => setServices([]));
  }, []);

  return (
    <div data-testid="services-page">
      <PageHero eyebrow="WHAT WE DO" title="OUR SERVICES" script="craft you can count on" />
      <section className="py-20 bg-paper">
        <div className="max-w-[1280px] mx-auto px-5 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
            {services.map((s, i) => (
              <Reveal key={s.id || s.title} delay={(i % 4) * 0.08}>
                <div className="bg-paper border border-navy/15 p-9 h-full group hover:bg-ink hover:border-ink transition-colors duration-500" data-testid={`service-${i}`}>
                  <div className="font-display text-gold text-4xl mb-4">{String(i + 1).padStart(2, "0")}</div>
                  <h3 className="font-display text-xl tracking-[0.04em] mb-3 group-hover:text-[#f2f0ea] transition-colors">{s.title.toUpperCase()}</h3>
                  <p className="text-navy/65 text-sm leading-relaxed group-hover:text-white/60 transition-colors">{s.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal className="text-center mt-16">
            <Link to="/quote" data-testid="services-request-quote-btn" className="inline-block bg-ink text-[#f2f0ea] px-10 py-4 text-[13px] font-bold tracking-[0.18em] hover:bg-navy transition-colors">REQUEST A QUOTE</Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
